var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:{ 'button--active': _vm.value },on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_c('span',{staticClass:"button__item"}),_c('span',{staticClass:"button__item"})])}
var staticRenderFns = []

export { render, staticRenderFns }